import { Button } from "../Button";
import { MultilangTextInput } from "../Form/MultilangTextInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { ADD_STEP, EDIT_STEP } from "../../graphql/Mutations/StepMutation";
import { TextInput } from "../Form/TextInput";

export const StepFormComponent = ({ data, onSuccess, onError }) => {
  const { t } = useTranslation();
  const [editStep] = useMutation(EDIT_STEP);
  const [addStep] = useMutation(ADD_STEP);
  const formik = useFormik({
    initialValues: {
      name: {
        ru: "",
        az: "",
        en: "",
      },
      name_system: {
        ru: "",
        az: "",
        en: "",
      },
      help_title: {
        ru: "",
        az: "",
        en: "",
      },
      help_text: {
        ru: "",
        az: "",
        en: "",
      },
      key: "",
    },
    validationSchema: Yup.object({
      name: Yup.object().shape({
        ru: Yup.string().required(t("Объязательное поле")),
      }),
      key: Yup.string().required(t("Объязательное поле")),
    }),
    onSubmit: (values) => {
      setLoading(true);
      if (Number(formik.values.id) > 0) {
        editStep({
          variables: {
            id: Number(values.id),
            name: JSON.stringify(values.name),
            name_system: JSON.stringify(values.name_system),
            help_title: JSON.stringify(values.help_title),
            help_text: JSON.stringify(values.help_text),
            key: values.key,
          },
        })
          .then((response) => {
            if (!response.data.updateStep) {
              onError(t("Ошибка сохранения"));
            } else {
              onSuccess(response);
            }
          })
          .catch((error) => {
            onError(error);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        addStep({
          variables: {
            name: JSON.stringify(values.name),
            name_system: JSON.stringify(values.name_system),
            help_title: JSON.stringify(values.help_title),
            help_text: JSON.stringify(values.help_text),
            key: values.key,
          },
        })
          .then((response) => {
            if (!response.data.addStep) {
              onError(t("Ошибка сохранения"));
            } else {
              formik.setValues({
                name: {
                  ru: "",
                  az: "",
                  en: "",
                },
                name_system: {
                  ru: "",
                  az: "",
                  en: "",
                },
                help_title: {
                  ru: "",
                  az: "",
                  en: "",
                },
                help_text: {
                  ru: "",
                  az: "",
                  en: "",
                },
                key: "",
              });
              onSuccess(response);
            }
          })
          .catch((error) => {
            onError(error);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      formik.setFieldValue("id", data.id);
      formik.setFieldValue("key", data.key);
      data.name.map((dic) => {
        formik.setFieldValue(`name.${dic.lang}`, dic.value);
      });
      data.name_system.map((dic) => {
        formik.setFieldValue(`name_system.${dic.lang}`, dic.value);
      });
      data.help_title.map((dic) => {
        formik.setFieldValue(`help_title.${dic.lang}`, dic.value);
      });
      data.help_text.map((dic) => {
        formik.setFieldValue(`help_text.${dic.lang}`, dic.value);
      });
    }
  }, [data]);

  return (
    <form className="row" onSubmit={formik.handleSubmit}>
      <div className="col-md-6">
        <MultilangTextInput
          label={"Название"}
          value={formik.values.name}
          onChange={(text, lang) => {
            formik.setFieldValue(`name.${lang}`, text);
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.name}
          name={"name"}
        />
      </div>
      <div className="col-md-6">
        <MultilangTextInput
          label={"Название (системное)"}
          value={formik.values.name_system}
          onChange={(text, lang) => {
            formik.setFieldValue(`name_system.${lang}`, text);
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.name_system}
          name={"name_system"}
        />
      </div>
      <div className="col-md-6">
        <MultilangTextInput
          label={"Заголовок справки"}
          value={formik.values.help_title}
          onChange={(text, lang) => {
            formik.setFieldValue(`help_title.${lang}`, text);
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.help_title}
          touched={formik.touched.help_title}
          name={"help_title"}
        />
      </div>
      <div className="col-md-6">
        <MultilangTextInput
          label={"Текст справки"}
          value={formik.values.help_text}
          onChange={(text, lang) => {
            formik.setFieldValue(`help_text.${lang}`, text);
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.help_text}
          touched={formik.touched.help_text}
          name={"help_text"}
        />
      </div>
      <div className="col-md-6">
        <TextInput
          label={"Ключ"}
          value={formik.values.key}
          onChange={(event) => {
            formik.setFieldValue(`key`, event.target.value);
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.key}
          touched={formik.touched.key}
          name={"key"}
        />
      </div>
      <div className="col-md-12 text-center">
        <Button
          label={"Сохранить"}
          loading={loading}
          style={"btn btn-primary w-md"}
        />
      </div>
    </form>
  );
};
